import { PropsWithChildren, createContext, useContext } from "react";
import { useTranslation } from "react-i18next";

import { useConfig } from "./ConfigProvider";
import Price from "../types/Price";

const PriceFormatContext = createContext<(price: Price) => string>(() => "");

export const PriceFormatProvider = ({ children }: PropsWithChildren) => {
    const { i18n } = useTranslation();
    const { store } = useConfig();

    const format = (price: Price): string => {
        return new Intl.NumberFormat(`${i18n.language}-${store.country}`, {
            style: "currency",
            currency: price.currency
        }).format(Number(price.value));
    };

    return (
        <PriceFormatContext.Provider value={format}>
            {children}
        </PriceFormatContext.Provider>
    );
};

export const usePriceFormat = () => useContext(PriceFormatContext);
